// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__f4aLN","modal":"styles_modal__kOQIf","fadeIn":"styles_fadeIn__u6XcJ","closeButton":"styles_closeButton__gdrRh"};